import { ActionFunction, json } from '@remix-run/node';
import { Form, useActionData, useNavigation } from '@remix-run/react';
import { subscribeToNewsletter } from '~/providers/newsletter/newsletter';

export const action: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const email = formData.get('email') as string;
  const name = formData.get('name') as string;

  try {
    const res = await subscribeToNewsletter({ email, name });
    return json({ success: res.success });
  } catch (error) {
    console.error(error);
    return json({ success: false });
  }
};

export default function Newsletter() {
  const actionData = useActionData<{ success?: boolean }>();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <div className="mb-4 max-w-7xl mx-auto bg-[#FBF0FF] rounded-lg px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-6">
      <div>
        <h3 className="text-xl font-bold text-gray-900 px-4">
          Join the KTM Vape Community
        </h3>
        <p className="text-sm text-black mt-2 px-4">
          Subscribe to receive new product launches, exclusive discounts,
          seasonal promotions, and vaping tips.
        </p>
      </div>

      <Form
        method="post"
        className="flex flex-col md:flex-row w-full md:w-auto gap-4"
      >
        <input
          type="email"
          name="email"
          placeholder="Enter your email address"
          className="flex-1 md:w-80 px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-600 text-sm"
          required
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-[#3F0071] text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-purple-800 transition disabled:opacity-50"
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe'}
        </button>
      </Form>

      {actionData?.success && (
        <p className="text-sm mt-3 text-center md:text-left px-4 text-green-700">
          ✅ You’ve successfully subscribed!
        </p>
      )}
      {actionData?.success === false && (
        <p className="text-sm mt-3 text-center md:text-left px-4 text-red-700">
          ❌ Subscription failed. Please try again.
        </p>
      )}
    </div>
  );
}
